import React from 'react';
import { Camera, FileImage, AlertCircle } from 'lucide-react';

function FAQ() {
  return (
    <div className="max-w-4xl mx-auto px-4">
      <h1 className="text-3xl font-bold mb-8">Często zadawane pytania</h1>
      
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-6 flex items-center gap-2">
          <Camera className="w-6 h-6 text-red-500" />
          Jak dodać zdjęcie?
        </h2>
        <div className="space-y-4">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="font-medium mb-2">1. Kliknij przycisk "Dodaj zdjęcie"</h3>
            <p className="text-gray-600">
              Znajdziesz go w górnej części strony głównej. Po kliknięciu otworzy się okno dodawania zdjęcia.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="font-medium mb-2">2. Wybierz zdjęcia</h3>
            <p className="text-gray-600">
              Możesz wybrać do 5 zdjęć jednocześnie. Pamiętaj o limitach rozmiaru i wymaganiach technicznych.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="font-medium mb-2">3. Zatwierdź wybór</h3>
            <p className="text-gray-600">
              Sprawdź podgląd wybranych zdjęć i kliknij "Dodaj". Zdjęcia zostaną przesłane i pojawią się w galerii.
            </p>
          </div>
        </div>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-6 flex items-center gap-2">
          <FileImage className="w-6 h-6 text-red-500" />
          Wytyczne dla zdjęć
        </h2>
        <div className="space-y-4">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="font-medium mb-2">Limity i formaty</h3>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Maksymalnie 5 zdjęć jednocześnie</li>
              <li>Maksymalny rozmiar pojedynczego zdjęcia: 10 MB</li>
              <li>Łączny maksymalny rozmiar wszystkich zdjęć: 10 MB</li>
              <li>Dozwolone formaty: JPG, JPEG, PNG</li>
            </ul>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="font-medium mb-2">Jakość zdjęć</h3>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Zdjęcia powinny być ostre i wyraźne</li>
              <li>Unikaj zdjęć rozmazanych lub niewyraźnych</li>
              <li>Zadbaj o dobre oświetlenie</li>
              <li>Unikaj zdjęć z widocznym ziarnem lub szumem</li>
              <li>Nie przesyłaj zdjęć ze znakami wodnymi</li>
            </ul>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="font-medium mb-2">Kompozycja i kadrowanie</h3>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Zadbaj o prawidłowe wykadrowanie głównego obiektu</li>
              <li>Unikaj zbędnych elementów w kadrze</li>
              <li>Zwróć uwagę na poziom horyzontu</li>
              <li>Unikaj prześwietlonych lub niedoświetlonych obszarów</li>
            </ul>
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-6 flex items-center gap-2">
          <AlertCircle className="w-6 h-6 text-red-500" />
          Niedozwolone treści
        </h2>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <p className="text-gray-600 mb-4">
            Nie akceptujemy zdjęć zawierających:
          </p>
          <ul className="list-disc list-inside text-gray-600 space-y-2">
            <li>Treści obraźliwe lub nieodpowiednie</li>
            <li>Materiały chronione prawami autorskimi</li>
            <li>Treści reklamowe lub promocyjne</li>
            <li>Zdjęcia zawierające dane osobowe lub poufne informacje</li>
            <li>Treści niezgodne z prawem lub regulaminem serwisu</li>
            <li>Zdjęcia zawierające znaki wodne lub podpisy</li>
            <li>Treści o charakterze politycznym lub kontrowersyjnym</li>
            <li>Zdjęcia zawierające przemoc lub treści nieodpowiednie dla wszystkich grup wiekowych</li>
          </ul>
        </div>
      </section>
    </div>
  );
}

export default FAQ;